






































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapMutations } from "vuex";
import NavBar from "../components/NavBar.vue";
import Esign from "../components/esign.vue";
import Client from "../Client";
import Mutation from "../store/mutationTypes";
import Action from "../store/actionTypes";

@Component({
  components: {
    NavBar,
    Esign
  }
})
export default class Signup extends Vue {
  private email: string = "";

  private password: string = "";

  private account_number: string = "";

  private phone_number: string = "";

  private first_name: string = "";

  private last_name: string = "";

  private error: string = "";

  private show_password: boolean = false;

  private agreed_to_terms: boolean = false;

  toggleShow() {
    console.log(this.email);
    this.show_password = !this.show_password;
  }

  onReset() {}

  onSubmit(evt: Event) {
    evt.preventDefault();
    console.log(this.agreed_to_terms);
    if (!this.agreed_to_terms) this.error = "Please accept";
    else if (this.emailValid() && this.phoneValid()) {
      this.$store
        .dispatch(Action.SIGNUP, {
          email: this.email,
          password: this.password,
          account_number: this.sanitized_account_number,
          phone_number: this.sanitized_phone_number,
          first_name: this.first_name,
          last_name: this.last_name
        })
        .then(
          response => {
            this.$store.commit(Mutation.INIT_USER, {
              account_number: this.sanitized_account_number
            });
            this.$router.push({
              path: "confirm",
              query: {
                phone_number: this.sanitized_phone_number
              }
            });
          },
          error => {
            this.error = error.response.data.message;
          }
        );
    }
  }

  private get sanitized_account_number(): string {
    if (this.account_number !== undefined)
      return this.account_number.replace(/[() -]*/gi, "");
    return "";
  }

  private get sanitized_phone_number(): string {
    if (this.phone_number !== undefined)
      return this.phone_number.replace(/[(+) -]*/gi, "");
    return "";
  }

  hasError() {
    return this.error.length > 0;
  }

  emailValid() {
    return /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(this.email);
  }

  phoneValid() {
    console.log(this.phone_number.replace(/[(+) -]*/gi, ""));

    return (
      this.phone_number !== undefined &&
      this.sanitized_phone_number.length == 11
    );
  }

  accountValid() {
    return (
      this.account_number !== undefined &&
      this.sanitized_account_number.length == 16
    );
  }

  toggleAgree(value: boolean) {
    if (value) this.error = "";
    this.agreed_to_terms = value;
  }
}
